import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var ChevronUpDown = function ChevronUpDown(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.8457C11.5596 1.8457 11.2158 2.0498 10.7861 2.39355L3.53516 8.2373C3.20215 8.50586 3.00879 8.89258 3.00879 9.34375C3.00879 10.2139 3.71777 10.8369 4.50195 10.8369C4.87793 10.8369 5.24316 10.6865 5.59766 10.4072L12 5.27246L18.4023 10.4072C18.7568 10.6865 19.1221 10.8369 19.498 10.8369C20.2822 10.8369 20.9912 10.2139 20.9912 9.34375C20.9912 8.89258 20.7979 8.50586 20.4648 8.2373L13.2031 2.38281C12.7842 2.0498 12.4297 1.8457 12 1.8457ZM12 22.4385C12.4297 22.4385 12.7842 22.2451 13.2031 21.9014L20.4648 16.0469C20.7979 15.7783 20.9912 15.3916 20.9912 14.9512C20.9912 14.0703 20.2822 13.4473 19.498 13.4473C19.1221 13.4473 18.7568 13.6084 18.4023 13.8877L12 19.0117L5.59766 13.8877C5.24316 13.6084 4.87793 13.4473 4.50195 13.4473C3.71777 13.4473 3.00879 14.0703 3.00879 14.9512C3.00879 15.3916 3.20215 15.7783 3.53516 16.0469L10.7861 21.9014C11.2158 22.2344 11.5596 22.4385 12 22.4385Z"
  })));
};

ChevronUpDown.displayName = 'ChevronUpDown';
export default ChevronUpDown;